<template>
    <div class="shadow-1 z-[100]">
        <div class="pt-1 md:pt-2 bg-gradient-to-r from-primary to-secondary" />
        <div class="flex justify-between items-center px-3 xs:px-5 xl:px-3 py-4 md:py-5 xl:container">
            <div class="flex items-end">
                <img
                    v-if="!isMobileLogin()"
                    src="@/assets/images/header/fubonLogo.svg"
                    alt="富邦人壽|線上交易"
                    class="w-28 h-[1.49375rem] md:w-36 md:h-[1.91875rem] mr-2 md:mr-4 "
                >
                <!-- <p
                    class="text-black text-sm md:text-base font-medium leading-none md:leading-none cursor-pointer"
                    @click="showLeaveAlert(routeName.HOME)"
                >
                    線上交易專區
                </p> -->
            </div>
        </div>
    </div>
</template>
<script>
import { isMobileLogin } from '@/utils/is';

export default {
    setup() {
        return {
            isMobileLogin,
        };
    },
};
</script>
<style lang="scss" scoped>
.menu-list {
    @apply text-base lg:hover:bg-gray-50 text-gray-900 py-1 px-2 lg:px-3 rounded;
}
</style>
